<template>
  <div class="bg-background-dark">
    <main class="min-h-screen w-full">
      <slot />
    </main>
  </div>
</template>
